import { render, staticRenderFns } from "./ReviewCart.vue?vue&type=template&id=3c78418e&"
import script from "./ReviewCart.vue?vue&type=script&lang=js&"
export * from "./ReviewCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports